import React from 'react';
import Dashboard from '../../layout/Dashboard';
import CouponForm from '../../components/forms/CouponForm';

const CouponAdd = ({history}) => {
  const coupon = {
    couponCode: '',
    discountType: 'percentage',
    value: null,
    startDate: '',
    endDate: '',
    expirationDate: '',
    validationType: 'byDate',
    numberRenewalLimits: null,
    business_id: null,
    usageLimit: null,
    status: 'active',
    eligibleUsers: 'all',
    eligiblePlans: 'all',
    description: '',
    editable: true,
  };

  return (
    <Dashboard>
      <CouponForm
        history={history}
        coupon={coupon}
        namePage={'Cadastrar Novo Cupom'}
      />
    </Dashboard>
  );
};

export default CouponAdd;
